import useSWR from "swr"

import { apiClientCommon } from "services/apiClientCommon"
import { selectIsUserLoggedIn } from "stores/auth/authSlice"
import { useAppSelector } from "stores/hooks"

const priceDropAlertFetcher = async () => {
  const res = await apiClientCommon.priceDropAlertNotificationApi()
  return res?.data
}

const usePriceDropAlertNotification = (isPriceTab = true) => {
  const isLoggedIn = useAppSelector(selectIsUserLoggedIn)
  return useSWR(
    isPriceTab && isLoggedIn
      ? { url: `/user/price-drop-alert/notification` }
      : null,
    priceDropAlertFetcher,
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
      dedupingInterval: 3000,
      errorRetryCount: 3,
    },
  )
}

export default usePriceDropAlertNotification
